import { filterSchemaFieldsByVisibility } from '@modules/consolidator/utils/Filter/Filter.js'
import { ASSET_FORM_FIELD_CATALOG } from '@modules/consolidator/constants/register-asset/form-schema'

const deepMerge = ({ base = {}, override = {} } = {}) => {
  const merged = { ...base, ...override }

  if (base.props || override.props) {
    merged.props = {
      ...base.props,
      ...override.props,
    }
  }

  if (base.defaultConfig || override.defaultConfig) {
    merged.defaultConfig = {
      ...base.defaultConfig,
      ...override.defaultConfig,
    }
  }

  return merged
}

export const createAssetFormField = ({ fieldKey, override } = {}) => {
  const baseField = ASSET_FORM_FIELD_CATALOG[fieldKey]
  if (!baseField) {
    throw new Error(`Unknown asset form field key: ${fieldKey}`)
  }
  return deepMerge({ base: baseField, override: override || {} })
}

export const buildQuantityDecimalProps = (maxDecimals) => ({
  decimalLength: { min: 0, max: maxDecimals },
  autoDecimalMode: false,
  allowNegative: false,
})

export const buildAssetSchema = ({
  isEdit,
  requiredFields,
  optionalFields,
}) => {
  const schemaFields = [...(requiredFields || []), ...(optionalFields || [])]

  return filterSchemaFieldsByVisibility({
    schemaFields,
    isEdit,
  })
}
